import React, { useEffect, useRef, useState } from "react";
import { useRecoilState } from 'recoil';
import {
	baseIdState,
	calendarViewState,
	dateOfServiceState,
	dateWeekServiceState,
	dayOfServiceState,
	endDateOfServiceState,
	keyMapState,
	timezoneState,
	urlItinerariesState,
	userIDState,
	waypointsState,
	weeklyItineraryState,
} from "../recoil/atoms";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import listWeek from '@fullcalendar/list';
import axios from 'axios';
import moment from "moment";


const Calendar = () => {
	const [ dayOfService, setDayOfService ] = useRecoilState( dayOfServiceState );
	const [ timezone, setTimeZone ] = useRecoilState( timezoneState );
	const [ urlItineraries, setUrlItineraries ] = useRecoilState( urlItinerariesState );
	const [ calendarView, setCalendarView ] = useRecoilState( calendarViewState );
	const calendarRef = React.createRef();
	const [ calendarKey, setCalendarKey ] = useState( 0 );
	const [ fetching, setFetching ] = useState( false );
	const [ orders, setOrders ] = useState( undefined );
	const [ userId, setUserId ] = useRecoilState( userIDState );
	const [ itinerary, setItinerary ] = useRecoilState( weeklyItineraryState );
	const [ basePlaceId, setBasePlaceId ] = useRecoilState( baseIdState );
	const [ endDate, setEndDate ] = useRecoilState( endDateOfServiceState );
	const [ currentDate, setCurrentDay ] = useRecoilState( dateOfServiceState );
	const [ currentWeekDate, setCurrentWeekDate ] = useRecoilState( dateWeekServiceState );
	const [ waypoints, setWaypoints ] = useRecoilState( waypointsState );
	const [ key, setKey ] = useRecoilState( keyMapState );
	const [ businessHours, setBusinessHours ] = useState( [] );
	const isUpdating = useRef(false);
	const [ offsetScroll, setOffsetScroll ] = useState(0);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const dateParam = urlParams.get('date');

		if (dateParam) {
			const parsedDate = moment(dateParam).format("YYYY-MM-DD");
			if (moment(parsedDate).isValid()) {
				setCurrentDay(parsedDate);
				setCurrentWeekDate(parsedDate);
				setEndDate(parsedDate);
				setCalendarView('timeGridDay');
			}
		}
	}, []);

	const handleChanges = ( info, day, date ) => {
		let _date = moment( date ).format( "YYYY-MM-DD" );
		setCurrentDay( _date );
		setDayOfService( day );
		scrollToTop();
	};

	useEffect( () => {
		if ( calendarRef && calendarRef.current && currentDate ) {

			calendarRef.current
				.getApi()
				.gotoDate( currentDate );
		}
	}, [ calendarRef, currentDate ] )

	useEffect( () => {
		if ( calendarRef && calendarRef.current ) {
			if ( calendarRef.current.calendar.state.viewType !== calendarView ) {
				changeView( calendarRef, calendarView ); //'timeGridDay'
			}
			scrollToTop();
		}
	}, [ calendarRef ] )

	useEffect( () => {

		scrollToTop();
	}, [ key ] )

	const changeView = ( dateClickInfo, view ) => {
		setCalendarView( view );
		if ( calendarRef && calendarRef.current ) {
			calendarRef.current
				.getApi()
				.changeView( view, dateClickInfo.date );
			scrollToTop();
		}
		setKey( key => key + 1 );
	}

	const apiCallItinerary = ( payload, id ) => {
		let link = id === null ? '/itineraries.json' : '/itineraries/' + id + '.json';

		axios( {
			url: link,
			method: id === null ? 'post' : 'put',
			data: payload,
			headers: {
				"Content-Type": "application/json",
				"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
			}
		} )
			.then( response => {
				setTimeout( () => {
					setOrders( undefined );
					setItinerary( [] );
					setBusinessHours([]);
				}, 800 )
			} )
			.catch( error => {
				M.toast( { html: error.message, displayLength: 3000, classes: 'error' } );
				console.error( 'Error creating orders:', error );
			} );

	}

	const createOrders = ( order ) => {
		if ( !order ) return;

		function extractIds ( orders ) {
			return orders.map( order =>
				order.status === "pre_created" ? { parent_id: order.parent_id } : { id: order.id }
			);
		}

		const updatedOrders = extractIds( order.events );

		if ( order.id === null ) {
			// create case
			const payload = {
				itinerary: {
					status: order.status,
					user_id: order.user.id,
					date: moment( order.date ).format( "MM/DD/YYYY" ),
					// position: order.position,
					// approved: false,
					orders_attributes: updatedOrders
				}
			};
			apiCallItinerary( payload, null );
		} else {
			// update case
			const payload = {
				itinerary: {
					status: order.status,
					user_id: order.user.id,
					date: moment( order.date ).format( "MM/DD/YYYY" ),
					// position: order.position,
					// approved: order.id !== null ? !order.approved : false,
					id: order.id !== null ? order.id : null,
					orders_attributes: updatedOrders
				}
			};
			apiCallItinerary( payload, order.id );
		}
	};

	function renderButton ( data ) {
		const textButton = data.id === null ? 'Generate' : data.approved ? 'Approved' : 'Approve';
		const classButton = data.approved ? "btn btn-disabled" : "btn btn-success";
		const tooltipButton = data.approved ? 'data-toggle="tooltip" data-placement="top" title="Click to unapprove"' : '';

		const isPastDate = moment(data.date).isBefore() && moment(data.date).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD') ;

		if (isPastDate) return `<div class="my-1 approval-actions"></div>`;

		let dataEvents = [];
		let dataLocations = [];
		if (data.events) {
			data.events.map(el => {
				dataEvents.push({
					approved: el.approved,
					status: el.status,
					id: data.id === null ? null : el.id,
					parent_id: data.id === null ? el.id : null,
					itinerary_id: el.itinerary_id,
					resourceId: el.resourceId,
					shift: el.shift,
					crew: el.crew
				})
			})
		}
		if (data.locations) {
			data.locations.map(el => {
				dataLocations.push({
					id: el.id,
					lat: el.lat,
					lng: el.lng,
				})
			})
		}
		let formattedData = {
			...data,
			events: dataEvents,
			orders: data.id === null ? [] : dataEvents,
			locations: dataLocations
		};

		return `<div class="my-1 approval-actions">
			<button 
				class='${classButton}'
				${tooltipButton}
				data-json='${JSON.stringify( formattedData )}'
				onclick='window.handleCalendarButtonClick(event);'
			>${textButton}</button>
		</div>`;
	}

	useEffect( () => {
		window.handleCalendarButtonClick = (event) => {
			const button = event.currentTarget;
			const jsonData = button.getAttribute('data-json');

			createOrders( JSON.parse(jsonData) );
		};

		return () => {
			// Cleanup
			delete window.handleCalendarButtonClick;
		};
	}, [] );

	const approveRouteView = ( info ) => {
		let selected_date = info.date,
			today = moment( selected_date ).local().format( "YYYY-MM-DD" ),
			header = $( '.fc-day-header[data-date="' + today + '"]' );
		let dayObj = itinerary.filter( el => el.date === today );

		if ( dayObj.length > 0 ) {
			let html = renderButton( dayObj[ 0 ] );
			const selector = '.fc-day-header[data-date="' + today + '"]';
			const approvalSelector = document.querySelector( selector );

			if ( approvalSelector && approvalSelector.querySelector( '.approval-actions' ) ) {
				return;
			}
			header.append( html );
		}
	}

	function isWithinBusinessHours(start, end, businessHours) {
		const businessStartTime = new Date(start);
		const businessEndTime = new Date(end);

		try {
			// Set the time to the start and end of business hours
			businessStartTime.setHours(parseInt(businessHours.startTime.split(':')[0]));
			businessStartTime.setMinutes(parseInt(businessHours.startTime.split(':')[1]));
			businessEndTime.setHours(parseInt(businessHours.endTime.split(':')[0]));
			businessEndTime.setMinutes(parseInt(businessHours.endTime.split(':')[1]));

			return start >= businessStartTime && end <= businessEndTime;
		} catch ( e ) {
			return true
		}
	}

	function getDayOfWeek(dateStr) {
		return moment( dateStr ).day();
	}

	const handleEventDrop = ( info, calendar ) => {
		let timezone = $( 'body' ).attr( 'data-timezone' );
		let oldDateShort = moment( info.oldEvent.start ).tz( timezone ).format( 'YYYY-MM-DD' );
		let eventsToday = itinerary.find( el => el.date === oldDateShort );
		let newDateEvent = moment( info.event.start ).tz( timezone ).format( 'YYYY-MM-DD' );
		let resourceItinerary = itinerary.find(el => el.date === newDateEvent);

		const divForScroll = document.querySelector( '.fc-time-grid' );
		const divScroller = document.querySelector( '.fc-scroller' );
		let divScrollerPos = +(getOffset( divScroller ).top);
		let divForScrollPos = +(getOffset( divForScroll ).top);
		const droppedStart = moment(info.event.start).tz(timezone).local();
		const droppedEnd = moment(info.event.start).tz(timezone).local().add(info.event._def.extendedProps.duration, 'hours');
		let dayOfWeek = getDayOfWeek(info.event.start);
		let _businessHours = businessHours.find(hour => hour.daysOfWeek.includes(dayOfWeek));

		if ( divScroller && divForScroll ) {

			let diffOffset = divScrollerPos - divForScrollPos;
			setOffsetScroll( diffOffset );
		}
		if (businessHours && !isWithinBusinessHours(droppedStart, droppedEnd, _businessHours)) {
			// Prevent dropping events outside business hours
			M.toast( { html: "Sorry, user does not work in current date/shift", displayLength: 3000, classes: 'error' } );
			info.revert(info); // Revert the event to its original position
		} else if ( eventsToday ) {
			 dropOrderEvent( info, calendar, [userId], resourceItinerary.id );
			setTimeout( () => {
				setOrders( undefined )
				setItinerary( [] );
				setBusinessHours([]);
			}, 800 )
		}
	};

	useEffect( () => {
		if ( calendarView === 'timeGridDay' ) {
			let currentRoutes = [];
			itinerary.forEach( ( r ) => {
				if ( r.date === currentDate ) {
					currentRoutes = r;
					return r;
				}
			} );
			let _wayPoints = [];
			if ( currentRoutes ) {
				_wayPoints.push( basePlaceId );
			}
			if ( currentRoutes.locations ) {
				currentRoutes.locations.forEach( ( st ) => {
					if ( st.place_id ) {
						_wayPoints.push( st.place_id )
					}
				} );
			}
			setWaypoints( _wayPoints );
		}
		scrollToTop();

	}, [ currentDate, itinerary, calendarView ] )

	function getOffset ( el ) {
		const rect = el.getBoundingClientRect();
		return {
			left: rect.left + window.scrollX,
			top: rect.top + window.scrollY
		};
	}

	let tries = 0;
	const scrollToTop = () => {
		const divForScroll = document.querySelector( '.fc-time-grid' );
		const divScroller = document.querySelector( '.fc-scroller' );

		try {
			let divScrollerPos = +(getOffset( divScroller ).top);
			let divForScrollPos = +(getOffset( divForScroll ).top);
			if ( divScroller && divForScroll ) {

				let diffOffset = divScrollerPos - divForScrollPos;
				if ( diffOffset !== offsetScroll && tries < 300 ) {
					divScroller.scrollTo( {
						top: offsetScroll,
					} );
					tries++;
				}
			}
			document.addEventListener( "scroll", scrollToTop );
		} catch ( e ) {}
	}

	function updateStartTimes ( orders ) {
		if ( orders.length === 0 ) return orders;

		let lastStartTime = null;

		return orders.map( ( order, index, arr ) => {
			lastStartTime = new Date( order.start );
			const date = moment( lastStartTime );
			const isUTC_Midnight = date.utc().hours() === 0 && date.utc().minutes() === 0 && date.utc().seconds() === 0;

			return {
				...order,
				// businessHours: {
				// 	startTime: '10:00',
				// 	endTime: '18:00'
				// }
				// allDay: isUTC_Midnight
			};
		} );
	}

	const fetchItinerary = async () => {
		try {
			setFetching( true );
			axios.get(
				urlItineraries + '&start=' + currentWeekDate + '&end=' + endDate
			)
				.then( ( response ) => {
					// const offsetOrders = updateStartTimes( response.data.orders );

					// successCallback(response.data.orders)
					if ( response.data.itinerary ) {
						setItinerary( response.data.itinerary );
					}
				} )
				.finally( ( response ) => {
					setFetching( false );
				} );
		} catch ( error ) {
			console.error( error );
		}
	}

	useEffect( () => {
		if ( !fetching && orders === undefined && urlItineraries ) {
			try {
				setFetching( true );
				axios.get(
					urlItineraries + '&start=' + currentWeekDate + '&end=' + endDate
				)
					.then( ( response ) => {
						const offsetOrders = updateStartTimes( response.data.orders );
						setOrders(offsetOrders  );
						// setOrders( response.data.orders  );

						if ( response.data.itinerary ) {
							setItinerary( response.data.itinerary );
						}
						if (response.data.business_hours) {
							setBusinessHours(response.data.business_hours)
						}
					} )
					.finally( ( response ) => {
						setFetching( false );
					} );
			} catch ( error ) {
				console.error( error );
			}
		}
	}, [ currentWeekDate, endDate, urlItineraries, orders ] )

	const createRecurringOrder = async ( data ) => {
		if (isUpdating.current) return; // Prevent multiple requests
		isUpdating.current = true;
		let orderModal = $( '#recurringOrderModal' );

		try {
			await axios( {
				method: 'post',
				url: '/orders.json',
				data: data,
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
				}
			} ).then( () => {
				M.toast( { html: 'Order created successfully', displayLength: 3000, classes: 'success' } );
				setOrders( undefined );
			} ).finally(()=>{
				isUpdating.current = false;
				orderModal.modal( 'hide' );
			});
		} catch ( error ) {
			showErrorText( error );
		}
	};

	const updateOrder = async (data) => {
		if (isUpdating.current) return; // Prevent multiple requests
		isUpdating.current = true; // Lock API call

		const id = data.order.order_id;
		let orderModal = $( '#orderModal' );

			axios( {
				method: 'put',
				url: `/orders/${id}.json`,
				data: data,
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
				}
			} ).then( () => {
				setTimeout( () => {
					setOrders( undefined );
					setItinerary( [] );
					// fetchItinerary();
				}, 100 );
				M.toast( { html: 'Order updated successfully', displayLength: 3000, classes: 'success' } );
			} ).catch( error => {
				Object.keys(error.response.data).forEach((key) => {
					M.toast( { html: error.response.data[key], displayLength: 3000, classes: 'error' } );
				});
				console.error( 'Error creating orders:', error.response );
			} ).finally(() => {
				isUpdating.current = false; // Unlock API call after completion
			});

			orderModal.modal( 'hide' );
	};

	// Request to delete recurring order
	const deleteRecurringOrder = async ( data ) => {
		if ( isUpdating.current ) return; // Prevent multiple requests
		isUpdating.current = true;
		let recurringOrderModal = $( '#recurringOrderModal' );

		try {
			await axios( {
				method: 'post',
				url: '/destroy_recurring_order.json',
				data: data,
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
				}
			} ).then( () => {
				M.toast( { html: 'Order deleted successfully', displayLength: 3000, classes: 'success' } );
				setTimeout( () => {
					setOrders( undefined );
					setItinerary( [] );
					// fetchItinerary();
				}, 100 );
			} ).finally( () => {
				isUpdating.current = false;
				recurringOrderModal.modal( 'hide' );
			} );
		} catch ( error ) {
			showErrorText( error );
		}
	}


	if ( orders === undefined )
		return <div className="w-100 h-100 d-flex align-items-center justify-content-center ">
			<div className="spinner-border">
				<span className="sr-only">Loading...</span>
			</div>
		</div>;

	return <div className="calendar-routes">
		{/*<p>StartWeek: {currentWeekDate}, CurrentDate: {currentDate}, CurrentDay: {dayOfService}, EndWeek: {endDate}, CalendarView:  {calendarView}</p>*/}
		<FullCalendar
			key={calendarKey}
			plugins={[
				timeGridPlugin,
				dayGridPlugin,
				interactionPlugin,
				momentTimezonePlugin,
				listWeek,
			]}
			slotDuration='00:30'
			// slotMinTime='04:30'
			// slotLabelInterval='04:30'
			timeZone={timezone}
			initialView={calendarView}
			initialDate={currentDate}
			// eventOverlap={false}
			contentHeight={window.mobileCheck() ? 'auto' : 725}
			editable={true}
			droppable={true}
			selectable={true}
			customButtons={{
				prevDay: {
					icon: 'fc-icon fc-icon-chevron-left',
					click: function () {
						if ( calendarView === 'timeGridDay' ) {
							let currentDay = calendarRef.current.calendar.state.currentDate;
							let prevDate = new Date( currentDay );
							prevDate.setDate( prevDate.getDate() - 1 );

							const previousDate = moment( currentDate ).subtract( 1, "day" );
							const formattedDate = previousDate.format( "YYYY-MM-DD" );
							const dayName = previousDate.format( "dddd" ).toLowerCase();

							if ( moment( currentWeekDate ).isAfter( moment( previousDate ) ) ) {
								const _newStartDate = moment( previousDate ).startOf( "week" ).format( "YYYY-MM-DD" );
								const _currentWeekDate = moment( previousDate ).endOf( "week" ).format( "YYYY-MM-DD" );
								// setEndDate( _currentWeekDate );
								// setCurrentWeekDate( _newStartDate );
								setCurrentWeekDate( formattedDate );
								setEndDate( formattedDate );

								setOrders( undefined );
								setBusinessHours([]);
								changeView( calendarRef, 'timeGridDay' );
							}

							handleChanges( calendarRef.current, dayName, formattedDate );
						}
						if ( calendarView === 'timeGridWeek' ) {
							let _newStartWeekDate = moment( currentWeekDate ).subtract( 1, 'week' );
							let _newStartWeekDateParsed = _newStartWeekDate.format( "YYYY-MM-DD" );
							const previousDate = moment( currentDate ).subtract( 7, "day" );
							const formattedDate = previousDate.format( "YYYY-MM-DD" );
							const dayName = previousDate.format( "dddd" ).toLowerCase();
							handleChanges( calendarRef.current, dayName, formattedDate );

							if ( moment( currentWeekDate ).isAfter( moment( _newStartWeekDateParsed ) ) ) {
								const _newStartDate = moment( previousDate ).startOf( "week" ).format( "YYYY-MM-DD" );
								const _currentWeekDate = moment( previousDate ).endOf( "week" ).format( "YYYY-MM-DD" );
								setEndDate( _currentWeekDate );
								setCurrentWeekDate( _newStartDate );
								setOrders( undefined );
								setBusinessHours([]);
								changeView( calendarRef, 'timeGridWeek' );

							} else {
								setCurrentWeekDate( _newStartWeekDateParsed );
								setFetching( true );
								changeView( calendarRef, 'timeGridWeek' );
							}
						}
					}
				},
				nextDay: {
					icon: 'fc-icon fc-icon-chevron-right',
					click: function () {
						if ( calendarView === 'timeGridDay' ) {
							const newNextDate = moment( currentDate ).local().add( 1, "day" );
							const nextDay = moment( newNextDate ).local().format( 'dddd' ).toLowerCase();

							if ( moment( newNextDate ).isAfter( moment( endDate ) ) ) {
								const _newEndDate = moment( newNextDate ).local().format( "YYYY-MM-DD" );

								setCurrentWeekDate( _newEndDate );
								setEndDate( _newEndDate );
								setOrders( undefined );
								setBusinessHours([]);
								changeView( calendarRef, 'timeGridDay' );
							}

							handleChanges( calendarRef.current, nextDay, newNextDate );
						}
						if ( calendarView === 'timeGridWeek' ) {
							let _newStartWeekDate = moment( currentWeekDate ).add( 1, 'week' );
							let _newStartWeekDateParsed = _newStartWeekDate.format( "YYYY-MM-DD" );
							const previousDate = moment( currentDate ).add( 7, "day" );
							const formattedDate = previousDate.format( "YYYY-MM-DD" );
							const dayName = previousDate.format( "dddd" ).toLowerCase();
							handleChanges( calendarRef.current, dayName, formattedDate );

							if ( moment( _newStartWeekDateParsed ).isAfter( moment( endDate ) ) ) {
								const _newEndDate = moment( previousDate ).endOf( "week" ).format( "YYYY-MM-DD" );
								setEndDate( _newEndDate );
								setOrders( undefined );
								setBusinessHours([]);
								setCurrentWeekDate( _newStartWeekDateParsed );
							} else {
								setCurrentWeekDate( _newStartWeekDateParsed );
								setFetching( true );
							}
						}
					}
				},
				selectDay: {
					text: 'Select day',
					click: function() {
						if (document.querySelector('input.datepicker-selector')) {
							const datepicker = document.querySelector('input.datepicker-selector');
							datepicker.classList.toggle('show');
						} else {
							const datepicker = document.createElement('input');
							datepicker.type = 'date';
							datepicker.className = 'form-control datepicker-selector show';
							datepicker.style.position = 'absolute';
							datepicker.style.left = '14px';
							datepicker.style.width = '220px';
							datepicker.style.top = '40px';
							datepicker.style.zIndex = '1000';
							currentDate ? datepicker.value = currentDate : null;
							datepicker.click(); // Programmatically open the date picker

							document.querySelector('.fc-header-toolbar').appendChild(datepicker);

							datepicker.addEventListener('change', (e) => {
								const formattedDate = moment( e.target.value ).local().format( 'YYYY-MM-DD' );
								const dayName = moment( e.target.value ).local().format( 'dddd' ).toLowerCase();

								setCurrentWeekDate(e.target.value);
								setEndDate(e.target.value);
								setCurrentDay(e.target.value);
								setOrders(undefined);
								setBusinessHours([]);

								changeView(calendarRef, 'timeGridDay');
								handleChanges(calendarRef.current, dayName, formattedDate);
							});
						}
					}
				},
				timeGridDay: {
					text: "Day",
					click: function ( dateClickInfo ) {
						setCurrentWeekDate(currentDate);
						setEndDate(currentDate);
						changeView( dateClickInfo, 'timeGridDay' );
					}
				},
				timeGridWeek: {
					text: "Week",
					click: function ( dateClickInfo ) {

						if (calendarView === "timeGridDay") {
							let _newStartWeek = moment(currentDate).startOf( "week" ).format( "YYYY-MM-DD" );
							let _newEndWeek = moment(currentDate).endOf( "week" ).format( "YYYY-MM-DD" );
							setCurrentWeekDate( _newStartWeek );
							setEndDate( _newEndWeek );
							setOrders( undefined );
							setItinerary( [] );
							setBusinessHours([]);
						}

						changeView( dateClickInfo, 'timeGridWeek' );
					}
				},
				goToday: {
					text: "Today",
					click: function () {
						let nextDate = new Date();
						let nextDay = nextDate.toLocaleDateString( "en-US", { weekday: "long" } ).toLowerCase();
						let today = moment( nextDate ).format( "YYYY-MM-DD" );

						setCurrentWeekDate( today );
						setEndDate( today );
						setOrders( undefined );
						setItinerary( [] );
						setBusinessHours([]);

						changeView( calendarRef, 'timeGridDay' );
						handleChanges( calendarRef.current, nextDay, nextDate );
					}
				}
			}}
			header={{

					left: 'goToday prevDay,selectDay,nextDay',
					center: 'title',
					right: 'timeGridWeek,timeGridDay'

			}}
			businessHours={businessHours}
			/*businessHours= {
				[ // specify an array instead
					{
						daysOfWeek: [ 1, 2, 3 ], // Monday, Tuesday, Wednesday
						startTime: '08:00', // 8am
						endTime: '18:00' // 6pm
					},
					{
						daysOfWeek: [ 4, 5 ], // Thursday, Friday
						startTime: '10:00', // 10am
						endTime: '16:00' // 4pm
					},
					{
						daysOfWeek: [ 0 ], // Thursday, Friday
						startTime: '08:00', // 10am
						endTime: '17:00' // 4pm
					}
				]
			}*/
			views={{
				dayGridMonth: { eventLimit: 4 },
				timeGridDay: {
					titleFormat: {
						weekday: 'short',
						month: 'short',
						day: 'numeric',
						year: 'numeric'
					}
				},
				timeGridWeek: { buttonText: 'Week'}
			}}
			events={orders}
			rerenderDelay={0}
			eventDisplay='list-item'
			eventOrder={"start,status,title"}
			eventRender={function ( info ) {
				renderOrderRoute( info, info.event.extendedProps.duration );
			}}
			dayRender={function ( info ) {
				approveRouteView( info )
			}}
			eventClick={function ( info ) {
				if ( info.event.extendedProps.status === 'pre_created' ) {
					showRecurringOrderModal( info );

					$( document ).on( 'submit', '#recurringOrderModal', function ( e ) {
						e.preventDefault();
						var data = getRecurringOrderFormData( $( this ) );
						createRecurringOrder( data, this );
					} );

					// Show delete recurring order dialog
					$(document).on('click', '#showDeleteRecurringOrderDialog', function (e) {
						e.preventDefault();
						$(this).parents('.modal-footer').hide();
						$('#deleteRecurringOrderDialog').show();
					});

					// Initiate requests to delete recurring order
					$(document).on('click', '#deleteRecurringOrderDialog button', function (e) {
						e.preventDefault();
						var cancel_recurring = $(this).attr('data-cancel-recurring') === 'true' ? 'true' : '',
							data = deleteRecurringOrderFormData($('#recurringOrderModal'), cancel_recurring);
						deleteRecurringOrder(data);
						$('.modal-footer').show();
						$('#deleteRecurringOrderDialog').hide();

						setTimeout(()=>{
							setOrders(undefined);
							setItinerary( [] );
						}, 500)
					});
				} else {
					showOrderModal( info );

					// Initiate requests to update order on forms submit
					$( document ).on( 'submit', '#orderModal', function ( e ) {
						e.preventDefault();
						var data = getOrderFormData( $( this ) );
						updateOrder( data );
					} );
				}
			}}
			eventDrop={function ( info ) {
				let timezone = $( 'body' ).attr( 'data-timezone' );
				let newDateShort = moment( info.event.start ).tz( timezone ).format( 'YYYY-MM-DD' );
				let eventsNew = itinerary.find( el => el.date === newDateShort );
				let oldDateShort = moment( info.oldEvent.start ).tz( timezone ).format( 'YYYY-MM-DD' );
				let eventsToday = itinerary.find( el => el.date === oldDateShort );

				// if (info.event._def.extendedProps.status === "pre_created"){
				// 	info.revert(info);
				// 	M.toast( { html: "Please create this order first", displayLength: 3000, classes: 'error' } );
				// } else
					if (eventsToday.approved || eventsNew?.approved) {
					info.revert(info);
					M.toast( { html: "Sorry, you can't change approved routes", displayLength: 3000, classes: 'error' } );
				} else if (!eventsNew) {
					info.revert(info);
					M.toast( { html: "Does not work in current date/shift", displayLength: 3000, classes: 'error' } );
				}
				else {
					handleEventDrop( info, this );
				}

			}}
			eventDragStart={function ( info ) {
				$( info.el ).attr( 'data-toggle', '' );
				$( '.tooltip' ).remove();
			}}
			eventReceive={
				function ( info ) {
					dropCreatedOrder( info, this );
				}
			}
			ref={calendarRef}
		/>
	</div>
}

export default Calendar
